angular
  .module('app')
  .component('templateFooter', {
    templateUrl: 'app/template/footer.html'
  });
